import React, { FC } from 'react';

//components
import AampeTooltip from '../../../../../components/shared/AampeTooltip/AampeTooltip';
import styled from 'styled-components';

//constants
import aampeTheme from '../../../../../constants/aampeTheme';
import { HEADER_TOOLTIP_CONTENT } from '../../../../../constants/formula';

interface SlateInputCharCountProps {
    showWarning: boolean;
    warningCount: number | undefined;
    charCountMessage: string;
}

interface StyledProps {
    isWarned?: boolean;
}

const SlateInputCharCount: FC<SlateInputCharCountProps> = ({
    showWarning,
    warningCount,
    charCountMessage,
}) => {
    return (
        <AampeTooltip
            title={
                showWarning
                    ? `${HEADER_TOOLTIP_CONTENT} Exceeding the character count limit(${warningCount}) might cause the headline to cut off for some users.`
                    : `${HEADER_TOOLTIP_CONTENT}`
            }
        >
            <CharCount contentEditable={false} isWarned={showWarning}>
                {charCountMessage}
            </CharCount>
        </AampeTooltip>
    );
};

const CharCount = styled.span.withConfig({
    shouldForwardProp: (prop) => !['isWarned'].includes(prop), // Prevent forwarding 'isWarned' prop to the DOM element
})<StyledProps>(({ isWarned }) => ({
    fontSize: aampeTheme.size.font.textSmall,
    fontWeight: 400,
    textAlign: 'right',
    userSelect: 'none',
    cursor: 'pointer',
    color: isWarned
        ? aampeTheme.colors.error500
        : aampeTheme.colors.textAccessibleWG01,
}));
export default SlateInputCharCount;
